import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Stack } from '@mui/material';
import { useSelector } from 'react-redux';

export default function BookingDiscountsLayout() {
    const settings = useSelector((state: any) => state?.settings?.data);
    const isInspectionEnabled = Boolean(settings?.profile?.inspection_module);

    // Inspection module does not support booking discount codes — block direct URL access
    if (isInspectionEnabled) {
        return <Navigate to="/calendar" replace />;
    }

    return (
        <Stack sx={{ width: '100%', p: { xs: 2, md: 4 } }}>
            <Outlet />
        </Stack>
    );
}
